import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success",
  "use": "icon-success-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-success\">\n    <path d=\"M11.987 1.49c-5.8 0-10.5 4.7-10.5 10.5s4.7 10.5 10.5 10.5c5.799 0 10.5-4.7 10.5-10.5s-4.701-10.5-10.5-10.5zm6.142 7.477L10.497 16.5 5.76 11.884l1.5-1.596 3.238 3.238 6.12-6.12 1.511 1.56z\" fill=\"#FFF\" fill-rule=\"nonzero\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol